module.exports = __webpack_public_path__ + "static/media/gryphon_musee_hero_currentexhibition_2.8ea9485a.jpg";